import { render, staticRenderFns } from "./TaxSubmission.vue?vue&type=template&id=7642fc0c&scoped=true"
import script from "./TaxSubmission.vue?vue&type=script&lang=js"
export * from "./TaxSubmission.vue?vue&type=script&lang=js"
import style0 from "./TaxSubmission.vue?vue&type=style&index=0&id=7642fc0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7642fc0c",
  null
  
)

export default component.exports